<div id="printContent">
  <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
    <img src="/assets/images/tutorialOverlayBttn.svg" />
  </button>
  <div class="header-controls split-flex">
    <h3>
      <img src="/assets/images/iconResources.svg" alt="Icon" /> Secure Data Sharing
    </h3>
  </div>

  <!-- File List Table -->
  <div *ngIf="files.length > 0" class="file-table">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <!-- Clickable header for File Name -->
          <th (click)="sortBy('fileName')" style="cursor:pointer;">
            File Name
            <fa-icon *ngIf="sortColumn==='fileName'" [icon]="sortDirection==='asc' ? faChevronDown : faChevronRight"></fa-icon>
          </th>
          <!-- Clickable header for Upload Date -->
          <th (click)="sortBy('uploadDate')" style="cursor:pointer;">
            Upload Date
            <fa-icon *ngIf="sortColumn==='uploadDate'" [icon]="sortDirection==='asc' ? faChevronDown : faChevronRight"></fa-icon>
          </th>
          <!-- Clickable header for Expiration Date -->
          <th (click)="sortBy('expirationDate')" style="cursor:pointer;">
            Expiration Date
            <fa-icon *ngIf="sortColumn==='expirationDate'" [icon]="sortDirection==='asc' ? faChevronDown : faChevronRight"></fa-icon>
          </th>
          <th>File Size</th>
          <th>Owner</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <!-- Search Bar Row -->
        <tr class="search-row" *ngIf="managementUser?.isCustomerServiceUser()">
          <td colspan="7">
            <input
              type="text"
              placeholder="Search..."
              [(ngModel)]="searchTerm"
              class="search-bar" />
          </td>
        </tr>
        <!-- File Rows -->
        <ng-container *ngFor="let file of sortedFilteredFiles; index as i">
          <!-- Main Row -->
          <tr class="main-row" (click)="toggleDetails(file.fileID || i)">
            <td class="id-column">{{ i + 1 }}</td>
            <td class="file-name-column">
              <!-- File expansion indicator icon -->
              <fa-icon [icon]="file.showDetails ? faChevronDown : faChevronRight" style="margin-right:5px;"></fa-icon>
              {{ file.fileName }}
            </td>
            <td class="upload-date-column">
              {{ file.uploadDate ? (file.uploadDate | date:'shortDate') : '-' }}
            </td>
            <td class="expiration-date-column">
              {{ file.expirationDate ? (file.expirationDate | date:'shortDate') : '-' }}
            </td>
            <td class="file-size-column">{{ formatFileSize(file.fileSize) }}</td>
            <td class="owner-column">
              {{ file.ownerUserID === managementUser?.userID ? 'You' : file.ownerUser!.firstName + ' ' + file.ownerUser!.lastName }}
            </td>
            <td class="actions-column">
              <!-- Conditionally render Share and Remove buttons only for the owner -->
              <ng-container *ngIf="file.ownerUserID === managementUser?.userID">
                <ng-container *ngIf="managementUser?.isCustomerServiceUser()">
                  <button class="action-share-button" (click)="shareAction(file.fileID || i); $event.stopPropagation()">Share</button>
                </ng-container>
                <button (click)="removeFile(file.fileID!); $event.stopPropagation()">Remove</button>
              </ng-container>
              <!-- Download button available to all -->
              <button class="download-button" (click)="downloadFile(file); $event.stopPropagation()">Download</button>
            </td>
          </tr>
          <!-- Detail Row -->
          <tr *ngIf="file.showDetails" class="detail-row">
            <td colspan="7">
              <div class="detail-content">
                <div><strong>Owner:</strong> {{ file.ownerUser!.firstName }} {{ file.ownerUser!.lastName }}</div>
                <div><strong>Email:</strong> {{ file.ownerUser!.email }}</div>
                <div><strong>District:</strong> {{ file.ownerUser!.districtName }}</div>
                <div><strong>School:</strong> {{ file.ownerUser!.school ? file.ownerUser!.school : 'N/A' }}</div>
                <div><strong>Type:</strong> {{ file.fileType }}</div>
                <div><strong>Size:</strong> {{ formatFileSize(file.fileSize) }}</div>
                <div *ngIf="file.description"><strong>Note:</strong> {{ file.description }}</div>
                <!-- Share Section (only visible to the owner) -->
                <div *ngIf="file.ownerUserID === managementUser?.userID">
                  <ng-container *ngIf="managementUser?.isCustomerServiceUser(); else nonFoundationsMsg">
                    <div class="share-section">
                      <div class="share-action">
                        <label for="emailInput{{getElementId(file)}}">Share with:</label>
                        <input
                          type="email"
                          id="emailInput{{getElementId(file)}}"
                          [(ngModel)]="file.newShareEmail"
                          placeholder="Enter email" />
                        <button class="share-action-button" (click)="addSharedEmail(file.fileID || i)">Share</button>
                      </div>
                      <div class="shared-users" *ngIf="file.sharedUsers && file.sharedUsers.length">
                        <span *ngFor="let user of file.sharedUsers; let j = index" class="shared-email">
                          {{ user.firstName }} {{ user.lastName }} ({{ user.email }})
                          <span class="remove-email" (click)="removeSharedEmail(file.fileID || i, j)">x</span>
                        </span>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #nonFoundationsMsg>
                    <p style="font-style: italic; color: gray;">
                      Uploaded files are automatically shared with FIL.
                    </p>
                  </ng-template>
                </div>
                <!-- End Share Section -->
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Upload Section with Drag and Drop -->
  <div class="upload-container"
       (dragover)="canUploadMoreFiles ? onDragOver($event) : $event.preventDefault()"
       (dragleave)="canUploadMoreFiles ? onDragLeave($event) : $event.preventDefault()"
       (drop)="canUploadMoreFiles ? onDrop($event) : $event.preventDefault()"
       [class.disabled]="!canUploadMoreFiles">
    <p *ngIf="canUploadMoreFiles">Drag and drop files here or click the button below to upload files.</p>
    <p *ngIf="!canUploadMoreFiles" class="upload-limit-message" style="color: red; font-weight: bold;">
      You have reached the maximum of 10 uploaded files. Please remove a file to upload more.
    </p>
    <!-- Upload subheading for non allowed users -->
    <p class="upload-subheading" *ngIf="!managementUser?.isCustomerServiceUser()">
      <em style="color: gray;">Uploaded files are automatically shared with the WordFlight support team</em>
    </p>
    <button class="upload-button" (click)="fileInput.click()" *ngIf="canUploadMoreFiles">Upload Files</button>
    <input #fileInput type="file" multiple (change)="onFileSelected($event)" hidden [disabled]="!canUploadMoreFiles">
  </div>
</div>
